import { instance } from './index';

export const GetDasboardPallets = (data) => instance.post('/dashboard/pallet', data);

export const GetDasboardArchived = (data) => instance.post('/dashboard/archived', data);

export const GetDasboardCollcted = (data) => instance.post('/dashboard/collected', data);

export const GetDasboardWarehouse = (data) => instance.post('/dashboard/warehouse-delay', data);
